type Props = any;
const DateIcon = ({ fill = "#fff" }): Props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={20} fill="none">
    <path
      fill={fill}
      d="M16 18H2V7h14m-3-7v2H5V0H3v2H2C.89 2 0 2.89 0 4v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1V0m-1 11H9v5h5v-5Z"
    />
  </svg>
);
export default DateIcon;
